// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ms-c";
export var backButton = "_ms-4";
export var backIcon = "_ms-5";
export var chevronShortcut = "_ms-6";
export var container = "_ms-1";
export var editor = "_ms-8";
export var editorWrapper = "_ms-7";
export var prefix = "_ms-2";
export var searchIcon = "_ms-3";
export var suffix = "_ms-9";
export var suffixContent = "_ms-a";
export var suffixText = "_ms-b";
export var wrapper = "_ms-0";